(function () {
  function init(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';
    var cats = root.querySelectorAll('[data-vb-faq-cat]');
    var items = root.querySelectorAll('[data-vb-faq-item]');

    function showCat(val) {
      cats.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-vb-faq-cat') === val);
      });
      items.forEach(function (item) {
        var match = item.getAttribute('data-category') === val;
        item.hidden = !match;
        if (!match) item.open = false;
      });
    }

    cats.forEach(function (cat) {
      cat.addEventListener('click', function () {
        showCat(cat.getAttribute('data-vb-faq-cat'));
      });
    });

    showCat('results');
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-faq]').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-vb-pdp-faq]');
    if (r) { r.dataset.init = '0'; init(r); }
  });
})();
